module.exports = __webpack_public_path__ + "img/favno.07a890f3.png";